export class DrillDownSortField {
  constructor(name = "", sortAscending = true) {
    this.Name = name;
    this.SortAscending = sortAscending;
  }
}
